import { inject } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../service/auth.service';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (localStorage.getItem('token')) {
    if(authService.getUserType()=="False"||null) {
      let toValidatePermission = route.data['permission']
      if (toValidatePermission && !authService.hasPermission(toValidatePermission))
          return router.navigate(['/dashboards/unauthorized']);
      return true
    }
    else {
      return router.navigate(['/dashboards/notFound']);
    }
  } else {
    localStorage.setItem('pathAnterior', state.url);
    return router.navigate(['/login'],
    {
      queryParams: {
        redirectTo: state.url
      },
    });
  }
};

export const authGuardClient: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if(localStorage.getItem('token')) {
    if(authService.getUserType()=="True") {
      return true;
    }
    else {
      return router.navigate(['/dashboards/notFound']);
    }
  }
  else {
    localStorage.setItem('pathAnterior', state.url);
    return router.navigate(['/login'],
    {
      queryParams: {
        redirectTo: state.url
      },
    });
  }

};


